import type { ThemeConfig } from 'antd';
import tokens from '@docs/design-tokens.json';

const color = tokens.color;

export const antdTheme: ThemeConfig = {
  token: {
    colorPrimary: color.accent.value,
    colorSuccess: color.success.value,
    colorWarning: color.warn.value,
    colorError: color.danger.value,
    colorInfo: color.info.value,
    colorText: color.fg.value,
    colorTextSecondary: color.muted.value,
    colorBorder: color.border.value,
    colorBgLayout: color.bg.value,
    colorBgContainer: color.surface.value,
    borderRadius: 8,
    fontFamily:
      '"Source Sans 3", "Noto Sans SC", "Source Han Sans SC", "PingFang SC", "Microsoft YaHei", sans-serif',
    fontFamilyCode: '"IBM Plex Mono", "Noto Sans SC", ui-monospace, monospace',
    controlHeight: 36,
    lineWidth: 1,
  },
  components: {
    Button: {
      primaryShadow: 'none',
      defaultShadow: 'none',
      borderRadius: 8,
      paddingInline: 16,
    },
    Layout: {
      siderBg: color.navBg.value,
      headerBg: color.surface.value,
      bodyBg: color.bg.value,
    },
    Menu: {
      darkItemBg: color.navBg.value,
      darkItemColor: color.navFg.value,
      darkItemSelectedBg: 'transparent',
      darkItemSelectedColor: color.navActive.value,
    },
    Table: {
      headerBg: color.surfaceWarm.value,
    },
  },
};
